// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__hDzMs","modal":"Modal_modal__gRGlg","slide-down":"Modal_slide-down__Ird2q"};